export enum RetirementExpenses {
  E50,
  E55,
  E60,
  E65,
  E70,
  E75,
  E80,
  E85,
  E90,
  E95,
  E100,
  E105,
  E110,
  E115,
  E120,
  E125,
  E130,
  E135,
  E140,
  E145,
  E150,
  Other,
}

export interface RetirementGoalData {
  principalName: string;
  principalAge: number;
  principalRetirementAge: number;
  principalRetirementAgeOptions: number[];
  principalIsRetired: boolean;
  spouseName: string;
  spouseRetirementAge: number;
  spouseRetirementAgeOptions: number[] | null;
  spouseIsRetired: boolean;
  retirementExpenses: RetirementExpenses;
  retirementExpensesOptions: { label: string; value: RetirementExpenses }[];
  retirementExpensesAmount: number;
}

export interface FormValues {
  principalIsRetired: boolean;
  spouseIsRetired: boolean;
  principalRetirementAge: number | string | null;
  spouseRetirementAge: number | string | null;
  retirementExpenses: RetirementExpenses;
  retirementExpensesAmount: number;
  assetBucketingIndices: number[];
}

export interface UpsertDTO extends FormValues {}
